// import {  useEffect, useState } from "react";
import { Home,Services,About,Contact,Root, PrivacyPolicy,ErrorPage, RemotePolicy } from "./Module_Exporter/Module_Exporter";
import 'react-toastify/dist/ReactToastify.css';
import {website_routes} from "./functions/DefaultValues";
import {createBrowserRouter,RouterProvider } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

// import AOS from 'aos';

// import 'aos/dist/aos.css'; 
// AOS.init({
//   duration: 1000,
//   offset:150
// });





function App() {


  const Router = createBrowserRouter([
    {
      path:"/",
      element:<><HelmetProvider>

      <Root/>
      </HelmetProvider>
      </>,
      errorElement:<ErrorPage/>,
      children:[
        
        {
          path:"/",
          element:<Home/>
    
        },
        {
          path:website_routes.home_page,
          element:<Home/>
    
        },
        {
          path:website_routes.services_page,
          element:<Services/>
    
        }
        ,
        {
          path:website_routes.contact_page,
          element:<Contact/>
    
        }
        ,
        {
          path:website_routes.about_page,
          element:<About/>
    
        }
        ,
        {
          path:website_routes.privacy_policy_page,
          element:<PrivacyPolicy/>
    
        }
        ,
        {
          path:website_routes.RemotePolicy_page,
          element:<RemotePolicy/>
    
        }
  ]
    }
   
  ])

 

  return (
  <>

  <RouterProvider router={Router} />

  </>
  );
}

export default App;
